import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Programme from "./pages/Programme";
import Sponsors from "./pages/Sponsors";
import Registration from "./pages/Registration";
import NominateSpeaker from "./pages/NominateSpeaker";
import { Toaster } from "./components/ui/toaster";

function App() {
  useEffect(() => {
    document.title = "Asia AI Alliance";
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/programme" element={<Programme />} />
          <Route path="/sponsors" element={<Sponsors />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/nominate-to-speak" element={<NominateSpeaker />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
